import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import router from './router'
import store from './store'

import 'core-js/fn/promise/finally'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import { API_ROOT } from './constants';

import Theme from './theme/Theme';

Vue.use(VueMaterial)
Vue.use(Vuex)

Vue.config.productionTip = false

new Vue({
	router,
	store,
	data: {
		API_URL: API_ROOT,
		THEME: Theme.getTheme(window.location.hostname),
	},
	render: h => h(App)
}).$mount('#app')
